import PropTypes from 'prop-types';
import React from 'react';

class DropdownOptionsInput extends React.Component {
  static propTypes = {
    dropdownOptions: PropTypes.array,
    handleAddDropdownOption: PropTypes.func,
    handleRemoveDropdownOption: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      newOptionText: '',
    };

    this.handleNewOptionInput = this.handleNewOptionInput.bind(this);
  }

  handleNewOptionInput(event) {
    this.setState({ newOptionText: event.target.value });
  }

  render() {
    const { dropdownOptions, handleAddDropdownOption, handleRemoveDropdownOption } = this.props;

    return (
      <div className="form-group" style={{ display: 'block' }}>
        <label>Dropdown options</label>

        {dropdownOptions &&
          dropdownOptions.map((opt) => {
            return (
              <div key={opt.id} className="row dropdown-input-group">
                <div className="col-lg-12">
                  <div className="input-group">
                    <span className="input-group-btn">
                      <button
                        className="btn btn-default remove-input-field removeButton"
                        type="button"
                        onClick={() => handleRemoveDropdownOption(opt.id)}
                      >
                        -
                      </button>
                    </span>
                    <input className="form-control" disabled value={opt.text} />
                  </div>
                </div>
              </div>
            );
          })}

        <div className="row dropdown-input-group">
          <div className="col-lg-12">
            <div className="input-group">
              <span className="input-group-btn">
                <button
                  id="addButton"
                  type="button"
                  className="btn btn-default"
                  onClick={() => {
                    handleAddDropdownOption(this.state.newOptionText);
                    this.setState({ newOptionText: '' });
                  }}
                >
                  +
                </button>
              </span>
              <input
                id="addInput"
                className="form-control"
                value={this.state.newOptionText}
                onChange={(event) => this.handleNewOptionInput(event)}
              />
            </div>
          </div>
        </div>
        <hr />
      </div>
    );
  }
}

export default DropdownOptionsInput;
